import type { ReactNode } from 'react';
import styles from './Pill.module.css';

export type PillKind = 'ok' | 'warn' | 'bad' | 'info' | 'idle' | 'accent' | 'neutral';

interface PillProps {
  kind?: PillKind;
  dot?: boolean;
  children: ReactNode;
  'aria-label'?: string;
}

const KIND_CLASS: Record<PillKind, string> = {
  ok: styles.ok,
  warn: styles.warn,
  bad: styles.bad,
  info: styles.info,
  idle: styles.idle,
  accent: styles.accent,
  neutral: '',
};

export function Pill({
  kind = 'neutral',
  dot = true,
  children,
  'aria-label': ariaLabel,
}: PillProps) {
  return (
    <span className={`${styles.pill} ${KIND_CLASS[kind]}`} aria-label={ariaLabel}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
}
